//Imports {{{
//}}}
import * as Yup from 'yup';
import Alert from '@mui/material/Alert';
import ArchivoMuyGrande from './archivo-muy-grande';
import Button from '@mui/material/Button';
import CallIcon from '@mui/icons-material/Call';
import CheckIcon from '@mui/icons-material/Check';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import EmailIcon from '@mui/icons-material/Email';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FeaturedVideoIcon from '@mui/icons-material/FeaturedVideo';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Grid from '@mui/material/Grid';
import HomeIcon from '@mui/icons-material/Home';
import InputLabel from '@mui/material/InputLabel';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LoadingButton from '@mui/lab/LoadingButton';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import React, {useState, useEffect, useContext} from 'react';
import Select from '@mui/material/Select';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Typography from '@mui/material/Typography';
import esLocale from 'date-fns/locale/es';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { RestContext } from '../../contexts/RestContext';
import { differenceInYears, format, parseISO } from 'date-fns';
import { useForm, Controller/*, useFieldArray*/ } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { yupResolver} from '@hookform/resolvers/yup';

const shortid = require('shortid');

const SelectorConvocatoria = props => { //{{{
    const validationSchema = Yup.object().shape({
        convocatoria: Yup.number('Seleccione una convocatoria válida').required(),
        dni: Yup.string().matches(/^[0-9]{8}$/, 'Ingrese un número de DNI válido').required(),
    });
    const formOptions = {
        resolver: yupResolver(validationSchema)
    };
    const {register, handleSubmit, setValue, watch,
            control, formState: {errors, isValid},
           } = useForm(formOptions);

    const [convocatoria, setConvocatoria] = useState(null);
    const [cargandoDNI, setCargandoDNI] = useState(false);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const watchConvocatoria = watch('convocatoria');
    const context = useContext(RestContext);

    if(!watchConvocatoria && props.convocatorias?.length) {
        setValue('convocatoria', props.convocatorias[0].id);
    }

    useEffect(() => {
        const c = props.convocatorias.find(x => x.id === watchConvocatoria);
        if(!c) return;

        setConvocatoria(c);
        setFechaInicio(format(c.postulacion_inicio, 'dd/MM/yyyy HH:mm'));
        setFechaFin(format(c.postulacion_fin, 'dd/MM/yyyy HH:mm'));
    }, [watchConvocatoria]);

    const onSubmit = values => {
        context.apipost(`/registros/postulacion/validacion`, values, true).then(response => {
                const data = response.data;
                setCargandoDNI(false);
                const payload = {
                    ...values,
                    dni: values.dni,
                    nombres: data.nombres,
                    apellido_paterno: data.apellido_paterno,
                    apellido_materno: data.apellido_materno,
                    direccion: data.direccion,
                };
                props.onClose(payload);
            })
            .catch(err => {
                setCargandoDNI(false);
            });
    }

    return <Dialog open={props?.open} onClose={props?.onClose} fullWidth maxWidth="sm">
            <DialogTitle>Selector de convocatorias</DialogTitle>
            <form noValidate onSubmit={handleSubmit(onSubmit)}>
                <DialogContent>
                    {convocatoria && <Alert type="info">
                        Recepción de postulaciones {fechaInicio} hasta {fechaFin}
                    </Alert>}
                    <Grid container spacing={2} sx={{mt: 1, mb: 1}}> {/*{{{ Grid de datos */}
                        <Grid item xs={12}>
                            <Controller
                                name="convocatoria" control={control}
                                render={( {field} ) => 
                                    <FormControl fullWidth>
                                        <InputLabel>Convocatoria</InputLabel>
                                        <Select fullWidth {...field}
                                            {...register('convocatoria')}
                                            label="Convocatoria"
                                            disabled={cargandoDNI}>
                                            {props.convocatorias.map((x,i) => (
                                                <MenuItem key={i} value={x.id}>{x.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                        <FormHelperText error={true}>{errors.convocatoria?.message}</FormHelperText>
                                    </FormControl>
                                }
                                defaultValue=""
                                />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField name="dni"  {...register('dni')} label="DNI" placeholder="DNI"
                                fullWidth disabled={cargandoDNI}
                                inputProps={{maxLength: 8, autoFocus: 'autofocus'}}
                                error={!!errors.dni?.message}
                                helperText={errors.dni?.message}
                                defaultValue=""
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <List>
                                {convocatoria?.resolucion_url &&
                                    <ListItem component="a" href={convocatoria.resolucion_url} target="new">
                                        <ListItemIcon><TextSnippetIcon/></ListItemIcon>
                                        <ListItemText primary={convocatoria.resolucion_titulo}/>
                                    </ListItem>}
                                {convocatoria?.bases_url &&
                                    <ListItem component="a" href={convocatoria.bases_url} target="new">
                                        <ListItemIcon><PlaylistAddCheckIcon/></ListItemIcon>
                                        <ListItemText primary={convocatoria.bases_titulo}/>
                                    </ListItem>}
                                {convocatoria?.cronograma_url &&
                                    <ListItem component="a" href={convocatoria.cronograma_url} target="new">
                                        <ListItemIcon><EventNoteIcon/></ListItemIcon>
                                        <ListItemText primary={convocatoria.cronograma_titulo}/>
                                    </ListItem>}
                            </List>
                        </Grid>
                    </Grid> {/*}}}*/}
                </DialogContent>
                {true && <DialogActions>
                    <LoadingButton type="submit" color="primary" loading={cargandoDNI}
                            disabled={!isValid || cargandoDNI}
                            fullWidth variant="contained">
                        Seleccionar
                    </LoadingButton>
                </DialogActions>}
            </form>
        </Dialog>
} //}}}

const Editor = props => {
    const [convocatorias, setConvocatorias] = useState([]);
    const [amgOpen, setAmgOpen] = useState(false);
    const [recomendaciones, setRecomendaciones] = useState([]);
    const [amgMaximaMedidaMb, setAmgMaximaMedidaMb] = useState(0);
    const [selectorConvocatoriaOpen, setSelectorConvocatoriaOpen] = useState(false);
    const [departamentos, setDepartamentos] = useState([]);
    const [departamentosAcademicos, setDepartamentosAcademicos] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [distritos, setDistritos] = useState([]);
    const [grupoRequisitos, setGrupoRequisitos] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [plazas, setPlazas] = useState([]);
    const [detallePlaza, setDetallePlaza] = useState(null);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        convocatoria: Yup.number('Seleccione una convocatoria válida').required(),
        dni: Yup.string().matches(/^[0-9]{8}$/, 'Ingrese un número de DNI válido').required(),
        nombres: Yup.string().max(100).required(),
        apellido_paterno: Yup.string().max(100).required(),
        apellido_materno: Yup.string().max(100),
        departamento: Yup.string().matches(/^[0-9]{6}$/, 'Ingrese un ubigeo válido').required(),
        provincia: Yup.string().matches(/^[0-9]{6}$/, 'Ingrese un ubigeo válido').required(),
        distrito: Yup.string().matches(/^[0-9]{6}$/, 'Ingrese un ubigeo válido').required(),
        direccion: Yup.string().max(100).required(),
        edad: Yup.number().min(18).required(),
        fecha_nacimiento: Yup.date().required(),
        sexo: Yup.string().required(),
        numero_celular: Yup.string().matches(/^[0-9]{9}$/, 'Ingrese un número valido').required(),
        correo_electronico: Yup.string().email().required(),
        departamento_academico: Yup.string().max(2).required(),
        plaza: Yup.number().required(),
    });
    const formOptions = {
        resolver: yupResolver(validationSchema),
        initialValues: {
            dni: '', convocatoria: '', convocatoria_nombre: '', nombres: '',
            apellido_paterno: '', apellido_materno: '',
            fecha_nacimiento: null, edad: 0, sexo: '',
            departamento: '', provincia: '', distrito: '',
            direccion: '', telefono_fijo: '', numero_celular: '',
            correo_electronico: '', departamento_academico: '',
            plaza: ''
        }
    };
    const {register, handleSubmit, setValue, reset, watch,
            getValues, control,
            formState: {errors, isValid},
           } = useForm(formOptions);
    const context = useContext(RestContext);
    const watchConvocatoria = watch('convocatoria');

    useEffect(() => {
        if(!loaded) {
            setLoaded(true);
            setSelectorConvocatoriaOpen(true)
            context.apiget('/convocatorias?incluir_plazas=1&incluir_plaza_requisitos=1&incluir_plaza_asignaturas=1', true)
                    .then(data => {

                        setConvocatorias(data.data.map(x => ({
                            ...x,
                            postulacion_inicio: parseISO(x.postulacion_inicio),
                            postulacion_fin: parseISO(x.postulacion_fin),
                        })));
                    });

            fetch('https://sysapis.uniq.edu.pe/api/dev/external/ubigeos?tipo=D').then(response => response.json())
                .then(data => {
                    setDepartamentos(data)
                });
        }
    }, []);



    //Handlers {{{
    const handleConvocatoriaClose = (e) => {
        if(!e.convocatoria) return;
        const convocatoria = convocatorias.find(x => x.id === e.convocatoria);
        setRecomendaciones(convocatoria.recomendaciones_ || []);

        const gr = [];
        let currentGrupoRequisitos = -1;
        (convocatoria.requisitos_ || []).forEach(x => {
            if(currentGrupoRequisitos !== x.grupo_requisitos) {
                gr.push({
                    id: x.grupo_requisitos,
                    nombre: x.grupo_requisitos_nombre,
                    orden: x.grupo_requisitos_orden,
                    requisitos_: []
                });
                currentGrupoRequisitos = x.grupo_requisitos;
            }

            gr[gr.length - 1].requisitos_.push({
                id: x.id,
                nombre: x.nombre,
                maximaMedidaMb: x.maxima_medida_mb || 0.1,
                obligatorio: x.obligatorio,
                urlPlantilla: x.url_plantilla,
                textoAdicional: x.texto_adicional,
                codigoPlugin: x.codigo_plugin,
                textoPlugin: x.texto_plugin,
                orden: x.orden,
                file: null,
            }); 
        });

        const dacds = [];
        convocatoria.plazas_.forEach(x => {
            let d = dacds.find(y => y.codigo === x.departamento_academico);
            if(! d) {
                dacds.push({codigo: x.departamento_academico, nombre: x.departamento_academico_nombre, plazas_: []});
                d = dacds[dacds.length - 1];
            }
            d.plazas_.push(x);
        });
        setDepartamentosAcademicos(dacds);
        reset(formOptions.initialValues);
        setValue('dni', e.dni);
        setValue('convocatoria', e.convocatoria);
        setValue('convocatoria_nombre', convocatoria.nombre);
        setValue('nombres', e.nombres);
        setValue('apellido_paterno', e.apellido_paterno);
        setValue('apellido_materno', e.apellido_materno);
        setValue('direccion', e.direccion);
        setSelectorConvocatoriaOpen(false);
        setPlazas(convocatoria.plazas_);
        setGrupoRequisitos(gr); 
    };

    const handleRequisitoFile = (e, idxGrupoRequisitos, idxRequisito) => {
        const gr = [...grupoRequisitos];
        if( !gr[idxGrupoRequisitos]  ||
            !gr[idxGrupoRequisitos].requisitos_[idxRequisito]) {
            window.alert('Requisito no definido');
            return;
        }

        const requisito = gr[idxGrupoRequisitos].requisitos_[idxRequisito];
        const maximaMedidaMb = requisito.maximaMedidaMb || 1;

        if(e.target.files[0].size > maximaMedidaMb*1048576) {
            setAmgMaximaMedidaMb(requisito.maximaMedidaMb);
            setAmgOpen(true);
            return;
        }


        const reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        reader.onload = () => {
            let err = true;
            if(reader.result?.length && reader.result.substr(0, 4) === '%PDF') {
                err = false;
            }
            if(err) {
                window.alert('El archivo no es PDF');
                return;
            }

            requisito.file = e.target.files[0];
            setGrupoRequisitos(gr);
        };
    };

    const handleFechaNacimientoChange = e => {
        let edad = 0;
        try {
            edad = differenceInYears(new Date(),  e);
            if(isNaN(edad) || edad<18 || edad>100) edad = 0;
        }
        catch(ex)  {
            edad = 0;
        }
        setValue('fecha_nacimiento', e);
        setValue('edad', edad);
    };

    const handleEjecutarPlugin = (e, codigoPlugin) => {
        if(!getValues('direccion'))  {
            window.alert('Debe ingresar una dirección');
            return;
        }
        if(!getValues('fecha_nacimiento'))  {
            window.alert('Debe ingresar una fecha de nacimiento');
            return;
        }
        if(!getValues('correo_electronico'))  {
            window.alert('Debe ingresar un correo electrónico');
            return;
        }
        if(!getValues('distrito'))  {
            window.alert('Debe ingresar los datos de departamento, provincia y distrito');
            return;
        }
        if(!getValues('numero_celular') || ! /^[0-9]{9}$/.test(getValues('numero_celular')) )  {
            window.alert('Debe ingresar un número de celular de 9 dígitos');
            return;
        }
        if(!getValues('departamento_academico'))  {
            window.alert('Debe ingresar un departamento académico');
            return;
        }
        if(!getValues('plaza'))  {
            window.alert('Debe ingresar una plaza');
            return;
        }
        const departamento_nombre = departamentos.find(x => x.codigo === getValues('departamento')).nombre;
        const provincia_nombre = provincias.find(x => x.codigo === getValues('provincia')).nombre;
        const distrito_nombre = distritos.find(x => x.codigo === getValues('distrito')).nombre;
        const plaza = plazas.find(x => x.id === getValues('plaza'));

        const payload = {
            ...getValues(),
            departamento_nombre,
            provincia_nombre,
            distrito_nombre,
            plaza_tipo_contrato: plaza.tipo_contrato,
            plaza_clase_contrato: plaza.clase_contrato,
        };

        switch(codigoPlugin) {
            case 'GENF01':
                context.apipost('/registros/formatos/GENF01', payload, false, {Accept: 'application/pdf'})
                    .then(response => response.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(new Blob([blob]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'formato01.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    })
                    .catch(err => {
                        console.log(err);
                    });
                break;
            case 'GENF02':
                context.apipost('/registros/formatos/GENF02', payload, false, {Accept: 'application/pdf'})
                    .then(response => response.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(new Blob([blob]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'formato02.pdf');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    })
                    .catch(err => {
                        console.log(err);
                    });
                break;
            default:
        }
    };

    const onSubmit = (values) => {
        if(!window.confirm('Se va a guardar el registro, proceder?')) return;

        const formData = new FormData();
        for(let k in values) formData.append(k, values[k]);
        const departamento = departamentos.find(x => x.codigo === values['departamento']);
        const provincia = provincias.find(x => x.codigo === values['provincia']);
        const distrito = distritos.find(x => x.codigo === values['distrito']);
        formData.append('fecha_nacimiento', format(values['fecha_nacimiento'], 'yyyy-MM-dd'));
        formData.append('departamento_nombre', departamento?.nombre);
        formData.append('provincia_nombre', provincia?.nombre);
        formData.append('distrito_nombre', distrito?.nombre);

        let i = 0;
        grupoRequisitos.forEach(x => {
            x.requisitos_.forEach(y => {
                formData.append(`requisitos_[${i}][id]`, y.id);
                if(y.file)
                    formData.append(`requisitos_[${i}][file]`, y.file);
                i++;
            });
        });
        
        context.apipost('/registros', formData, true, {'Content-Type': null},).then(data => {
            navigate('/postulacion-recibida');
        });
    };

    const formularioValido = () => {
        let todosRequisitos = true;
        grupoRequisitos.forEach(x => {
            x.requisitos_.forEach(y => {
                if(y.obligatorio && !y.file) todosRequisitos = false;
            });
        });
        return todosRequisitos;
    };

    const handleDepartamentoAcademicoChange = (e) => {
        const departamentoAcademico = e.target.value;
        const oda = departamentosAcademicos.find(x => x.codigo === departamentoAcademico);
        if(!oda) {
            setValue('departamento_academico', null);
            setPlazas([]);
            setValue('plaza', null);
            return;
        }
        const c = convocatorias.find(x => x.id === watchConvocatoria);
        const _plazas = c.plazas_.filter(x => x.departamento_academico === departamentoAcademico);
        setValue('departamento_academico', departamentoAcademico);
        setPlazas(_plazas);
        handlePlazaChange({target: {value: _plazas[0].id} });
    };

    const handlePlazaChange = (e) => {
        const plaza = e.target.value;
        const oda = departamentosAcademicos.find(x => x.codigo === getValues('departamento_academico'));
        const dp = oda.plazas_.find(x => x.id === plaza);
        setValue('plaza', plaza);
        setDetallePlaza(dp);
    };


    const handleDepartamentoChange = (e) => {
        const departamento = e.target.value;
        setValue('departamento', departamento);
        fetch(`https://sysapis.uniq.edu.pe/api/dev/external/ubigeos?tipo=P&padre=${departamento}`).then(response => response.json())
            .then(data => {
                setProvincias(data);
                setValue('provincia', data[0]?.codigo);
                handleProvinciaChange({target: {value: data[0]?.codigo} })
            })
    };

    const handleProvinciaChange = e => {
        const provincia = e.target.value;
        setValue('provincia', provincia);
        fetch(`https://sysapis.uniq.edu.pe/api/dev/external/ubigeos?tipo=I&padre=${provincia}`).then(response => response.json())
            .then(data => {
                setDistritos(data);
                setValue('distrito', data[0]?.codigo);
                handleDistritoChange({target: {value: data[0]?.codigo} })
            })
    };

    const handleDistritoChange = e => {
        setValue('distrito', e.target.value);
    };
    //}}}

    if(!watchConvocatoria) { //Diálogo selector de convocatoria {{{
        return <SelectorConvocatoria open={selectorConvocatoriaOpen}
                    convocatorias={convocatorias}
                    convocatoria={convocatorias?.length? convocatorias[0].id: null }
                    onClose={handleConvocatoriaClose} />
    } //}}}
    return <Container maxWidth="md">
            {amgOpen && <ArchivoMuyGrande
                open={true} maximaMedidaMb={amgMaximaMedidaMb}
                onClose={e => setAmgOpen(false)}/>}
            <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <Paper sx={{p: 2}}>
                {Boolean(recomendaciones) && <Alert>
                    Información sobre la postulación
                    <List>
                    {recomendaciones.map((x,i) => 
                        <ListItem key={i}>
                            <ListItemIcon><LabelImportantIcon/></ListItemIcon>
                            <ListItemText primary={x.mensaje}/>
                        </ListItem>
                    )}
                    </List>
                 </Alert>}

                <Typography variant="h4">Datos personales</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <TextField name="dni" {...register('dni')} label="DNI" placeholder="DNI"
                            fullWidth disabled
                            InputProps={{
                                startAdornment: <FeaturedVideoIcon/>
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <TextField name="convocatoria_nombre"
                            {...register('convocatoria_nombre')} 
                            label="Convocatoria" placeholder="Convocatoria"
                            fullWidth disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="nombres" {...register('nombres')} 
                            label="Nombres" placeholder="Nombres"
                            fullWidth disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="apellido_paterno" 
                            {...register('apellido_paterno')}
                            label="Apellido paterno" placeholder="Apellido paterno"
                            fullWidth disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="apellido_materno"
                            {...register('apellido_materno') }
                            label="Apellido materno" placeholder="Apellido materno"
                            fullWidth disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
                            <Controller control={control} name="fecha_nacimiento"
                                render={ ({field}) => 
                                    <DatePicker fullWidth inputFormat="dd/MM/yyyy"
                                        label="Fecha de nacimiento"
                                        {...register('fecha_nacimiento')}
                                        InputLabelProps={{
                                          shrink: true,
                                        }}
                                        InputProps={{required: true}}
                                        onChange={handleFechaNacimientoChange}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    /> }
                                  defaultValue={null}
                                />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="edad" {...register('edad')} 
                            label="Edad" placeholder="Edad" disabled
                            fullWidth required
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller name="sexo" control={control}
                            render={({field}) =>
                                <TextField name="sexo" fullWidth
                                    {...field} required
                                    select label="Sexo" placeholder="Sexo"
                                    error={!!errors.sexo?.message}
                                    helperText={errors.sexo?.message}>
                                    <MenuItem value="F">Femenino</MenuItem>
                                    <MenuItem value="M">Masculino</MenuItem>
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller name="departamento" control={control} defaultValue=""
                            render={({field}) =>
                                <TextField fullWidth
                                    {...field} required
                                    onChange={handleDepartamentoChange}
                                    select label="Departamento" placeholder="Departamento"
                                    error={!!errors.departamento?.message}
                                    helperText={errors.departamento?.message}>
                                    {departamentos.map((x,i)=> <MenuItem key={i} value={x.codigo}>{x.nombre}</MenuItem>)}
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller name="provincia" control={control} defaultValue=""
                            render={({field}) =>
                                <TextField name="provincia" fullWidth
                                    {...field} required
                                    onChange={handleProvinciaChange}
                                    select label="Provincia" placeholder="Provincia"
                                    error={!!errors.provincia?.message}
                                    helperText={errors.provincia?.message}>
                                    {provincias.map((x,i)=> <MenuItem key={i} value={x.codigo}>{x.nombre}</MenuItem>)}
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller name="distrito" control={control} defaultValue=""
                            render={({field}) =>
                                <TextField name="distrito" fullWidth
                                    {...field} required
                                    onChange={handleDistritoChange}
                                    select label="Distrito" placeholder="Distrito"
                                    error={!!errors.distrito?.message}
                                    helperText={errors.distrito?.message}>
                                    {distritos.map((x,i)=> <MenuItem key={i} value={x.codigo}>{x.nombre}</MenuItem>)}
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField name="direccion" fullWidth
                            label="Dirección" placeholder="Dirección"
                            {...register('direccion')} required
                            error={!!errors.direccion?.message}
                            inputProps={{maxLength: 100}}
                            InputProps={{startAdornment: <HomeIcon color="primary"/> }}
                            helperText={errors.direccion?.message}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="telefono_fijo" fullWidth
                            label="Teléfono fijo" placeholder="Teléfono fijo"
                            {...register('telefono_fijo')}
                            error={!!errors.telefono_fijo?.message}
                            helperText={errors.telefono_fijo?.message}
                            InputProps={{startAdornment: <CallIcon color="primary"/> }}
                            inputProps={{ maxLength: 10, }} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="numero_celular" fullWidth
                            label="Número celular" placeholder="Número celular"
                            {...register('numero_celular')}
                            error={!!errors.numero_celular?.message}
                            helperText={errors.numero_celular?.message}
                            InputProps={{startAdornment: <SmartphoneIcon color="primary"/> }}
                            inputProps={{ maxLength: 9, }} required/>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <TextField name="correo_electronico" type="email" fullWidth
                            label="Correo electrónico" placeholder="Correo electrónico"
                            {...register('correo_electronico')}
                            error={!!errors.correo_electronico?.message}
                            helperText={errors.correo_electronico?.message}
                            InputProps={{startAdornment: <EmailIcon color="primary"/> }}
                            required
                        />
                    </Grid>
                </Grid>
                <Typography variant="h4" sx={{mt: 4, mb: 2}}>
                    Datos de postulación <span style={{fontSize: '0.85rem'}}>(Indicar departamento académico y plaza)</span>
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={8}>
                        <Controller name="departamento_academico" control={control} defaultValue=""
                            render={({field}) =>
                                <TextField fullWidth 
                                    {...field}
                                    label="Departamento académico"
                                    placeholder="Departamento académico"
                                    select onChange={handleDepartamentoAcademicoChange}
                                    error={!!errors.departamento_academico?.message}
                                    helperText={errors.departamento_academico?.message}
                                    required
                                    >
                                    {departamentosAcademicos.map((x,i) =>
                                    <MenuItem key={shortid.generate()} value={x.codigo}>{x.nombre}</MenuItem>) }
                                </TextField>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Controller name="plaza" control={control} defaultValue=""
                            render={({field}) =>
                                <TextField fullWidth
                                    {...field} select
                                    label="Plaza" placeholder="plaza"
                                    onChange={handlePlazaChange}
                                    error={!!errors.plaza?.message}
                                    helperText={errors.plaza?.message}
                                    required
                                    >
                                        {plazas.map((x,i) =>
                                            <MenuItem key={shortid.generate()} value={x.id}>{x.nombre}</MenuItem>) 
                                        }
                                </TextField>
                            }
                        />
                    </Grid>
                    {Boolean(detallePlaza) && <Grid item xs={12}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Tipo de contrato</TableCell>
                                        <TableCell>Clase de contrato</TableCell>
                                        <TableCell>Asignatura</TableCell>
                                        <TableCell>Código</TableCell>
                                        <TableCell>Escuela profesional</TableCell>
                                        <TableCell>Horas</TableCell>
                                        <TableCell>Requisitos</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                   {detallePlaza.asignaturas_.map((x,i) =>  <TableRow key={shortid.generate()}>
                                        {i === 0 && <TableCell rowspan={detallePlaza.asignaturas_.length}>
                                                {detallePlaza.tipo_contrato}
                                            </TableCell>}
                                        {i === 0 && <TableCell rowspan={detallePlaza.asignaturas_.length}>
                                                {detallePlaza.clase_contrato}
                                            </TableCell>}
                                        <TableCell>{x.nombre}</TableCell>
                                        <TableCell>{x.codigo}</TableCell>
                                        <TableCell>{x.escuela_profesional_nombre}</TableCell>
                                        <TableCell>{x.horas}</TableCell>
                                        {i === 0 && <TableCell rowspan={detallePlaza.asignaturas_.length}>
                                            <ul>
                                            {detallePlaza.requisitos_.map((y,j) => <li key={shortid.generate()}>{y.nombre}</li> )}
                                            </ul>
                                        </TableCell>}
                                   </TableRow>)}                
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>}
                </Grid>
                <Typography variant="h4" sx={{mt: 4, mb: 2}}>Archivos de requisitos mínimos</Typography>
                <Typography variant="caption">Los campos marcados con * son obligatorios</Typography>
                {grupoRequisitos.map((x, i) => <div key={shortid.generate()}>
                    {Boolean(x.nombre) && <>
                            <Typography variant="h6">{x.orden}. {x.nombre}</Typography>
                        </> }
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <List>
                                {x.requisitos_.map((y, j) => <div key={shortid.generate()}><ListItem  
                                    secondaryAction={Boolean(y.file) && <CheckIcon color="secondary"/>}
                                    > 
                                    <ListItemAvatar>
                                        <Button component="label" color="primary" 
                                            variant={!y.file?'outlined': 'contained'}
                                            sx={{mr: 2}}
                                            startIcon={<FileUploadIcon />}>
                                            <input style={{display: 'none'}} type="file"
                                                onChange={ e => handleRequisitoFile(e, i, j) }
                                                accept="application/pdf"/>
                                            Max {y.maximaMedidaMb} Mb
                                        </Button>
                                    </ListItemAvatar>
                                    <ListItemText primary=<span>
                                            <Typography variant="body1">{Boolean(x.orden) && <>{x.orden}.</> } {y.orden} {y.nombre}{Boolean(y.obligatorio)&& <super>*</super>}
                                                {Boolean(y.codigoPlugin) && <Chip color="secondary" variant="outlined"
                                                    onClick={e => handleEjecutarPlugin(e, y.codigoPlugin) }
                                                    avatar=<PictureAsPdfIcon size="small"/> label={y.textoPlugin} />}
                                            </Typography>
                                        </span>
                                        secondary={y.textoAdicional}
                                    />
                                </ListItem>
                                <Divider/>
                               </div>)}
                            </List>
                        </Grid>
                    </Grid>
                </div>) }

                <Grid container>
                    <Button color="primary" variant="contained" type= "submit" disabled={!formularioValido() || !isValid}>
                        Registrar postulación
                    </Button>
                </Grid>
            </Paper>
            </form>
        </Container> 
    } //}}}

export default Editor;

